export enum TakeFiveView {
    Overview,
    TakeFive
}